import { Page } from '@connected/ui/features/layouts';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { HeaderNavigation } from '@/components/navigation/header-navigation';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/applications/those-involved',
)({
    component: Layout,
});

function Layout() {
    const { t } = useTranslation('applications');

    return (
        <Page>
            <Page.Header>
                <Page.Header.Bar>
                    <Page.Header.Title>{t('those-involved.title')}</Page.Header.Title>
                </Page.Header.Bar>
                <HeaderNavigation />
            </Page.Header>
            <Page.Outlet />
        </Page>
    );
}
